import React from "react";
import Header from "../../components/LPHeader";
import Footer from "../../components/LPFooter";
import Image1 from "../../assets/images/security_padlock_no_bg.png";

const PrivacyPolicy = () => {
    return (
        <div className="flex flex-col min-h-screen bg-white font-inter">
            <Header/>
            <main className="flex-grow">
                <div className="container mx-auto pt-8 mx-auto px-4 sm:px-6 lg:px-8 ">
                    <div className="container flex flex-col md:flex-row justify-between items-center mb-4 ">
                        <div className="md:w-1/2 w-full md:text-left text-center mb-4">
                            <h1 className="text-4xl md:text-7xl md:pb-4 pb-0 "><span className="font-bold">Privacy <span className="hidden sm:inline"><br/></span> Policy</span></h1>
                            <h2 className="text-2xl md:text-4xl ">Pre-Launch</h2>
                        </div>
                        <div className="w-full md:w-1/2 flex justify-end mb-4 md:mb-0">
                            <img src={Image1} 
                            alt="Security Padlock" 
                            className="w-2/3 md:w-1/2 object-cover mx-auto md:mx-0"/>
                        </div>
                    </div>
                    <div className="pb-2">
                        <h3 className="text-2xl md:text-4xl font-bold pb-6">What We Collect</h3>
                        <table className="min-w-full text-left border border-gray-200 text-base xl:text-xl 2xl:text-2xl">
                            <thead>
                                <tr >
                                    <th className="px-4 py-2 font-bold border-b border-r">Category</th>
                                    <th className="px-4 py-2 font-bold border-b">Example</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="px-4 py-2 border-b border-r text-[#5C5C5C]">Contact Info</td>
                                    <td className="px-4 py-2 border-b text-[#5C5C5C]">Name, email, phone</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-2 border-b border-r text-[#5C5C5C]">Education Info</td>
                                    <td className="px-4 py-2 border-b text-[#5C5C5C]">Institution, grade / year, role (e.g., student, club leader, admin)</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-2 border-b border-r text-[#5C5C5C]">Club Info</td>
                                    <td className="px-4 py-2 border-b text-[#5C5C5C]">Club name, type, size, activity level</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-2 border-b border-r text-[#5C5C5C]">Communication</td>
                                    <td className="px-4 py-2 border-b text-[#5C5C5C]">Messages or survey responses you send us</td>
                                </tr>
                                <tr>
                                    <td className="px-4 py-2 border-r text-[#5C5C5C]">Technical</td>
                                    <td className="px-4 py-2 text-[#5C5C5C]">IP address, browser type, device data, cookie ID</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="text-base xl:text-xl 2xl:text-2xl py-6">
                        <h3 className="text-2xl md:text-4xl font-semibold pb-4">How We Use It</h3>
                        <ul className="list-disc pl-8 marker:text-[#5379F6] text-[#5C5C5C]">
                            <li>To create and manage your Scholarty account or wait - list entry.</li>
                            <li>To send product-launch updates, beta invitations, and feature surveys.</li>
                            <li>To match you with the correct school / club workspace inside the platform.</li>
                            <li>We do not sell your data or share it with third parties for their own marketing.</li>
                        </ul>
                    </div>

                    <div className="text-base xl:text-xl 2xl:text-2xl py-6">
                        <h3 className="text-2xl md:text-4xl font-semibold pb-4">Your Choices</h3>
                        <ul className="list-disc pl-8 marker:text-[#5379F6] text-[#5C5C5C]">
                            <li>Opt-out: Click Unsubscribe in any email or email <a 
                                    className="text-blue-600 hover:underline" 
                                    href="mailto:privacy@scholarty.com">
                                    privacy@scholarty.com
                                    </a>.
                                </li>
                            <li>You may request a complete deletion of your email record at any time.</li>
                        </ul>
                    </div>

                    <div className="text-base xl:text-xl 2xl:text-2xl py-6">
                        <h3 className="text-2xl md:text-4xl font-semibold pb-4">Copyright / DMCA</h3>
                        <ul className="list-disc pl-8 marker:text-[#5379F6] text-[#5C5C5C]">
                            <li>We honor valid takedown notices sent to <a 
                                    className="text-blue-600 hover:underline" 
                                    href="mailto:copyright@scholarty.com">
                                    copyright@scholarty.com
                                </a>.
                            </li>
                        </ul>
                    </div>

                    <div className="text-base xl:text-xl 2xl:text-2xl pt-6 pb-24">
                        <h3 className="text-2xl md:text-4xl font-semibold pb-4">Changes</h3>
                        <ul className="list-disc pl-8 marker:text-[#5379F6] text-[#5C5C5C]">
                            <li>We'll post any updates here and email you if changes are material. Continued use after<br></br>
                            the effective date means you accept the revised Notice.</li>
                        </ul>
                    </div>
                </div>
            </main>
            <Footer/>
        </div>
    );
};export default PrivacyPolicy;